import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger } from "../ui/dropdown-menu";

function EllipsisPagination({
	totalPages,
	currentPage,
	onPageChange,
	rowsPerPage,
	setRowsPerPage,
	activePage,
	length,
	dataName,
}) {
	const maxDisplayedPages = 5;

	const generateDisplayedPages = () => {
		const pages = [];

		if (totalPages <= maxDisplayedPages) {
			for (let page = 1; page <= totalPages; page++) {
				pages.push(page);
			}
		} else {
			let startPage = currentPage - Math.floor(maxDisplayedPages / 2);
			if (startPage < 1) {
				startPage = 1;
			}
			const endPage = Math.min(startPage + maxDisplayedPages - 1, totalPages);

			if (startPage > 1) {
				pages.push("...");
			}
			for (let page = startPage; page <= endPage; page++) {
				pages.push(page);
			}
			if (endPage < totalPages) {
				pages.push("...");
			}
		}

		return pages;
	};

	const handlePageChange = (page) => {
		if (page === "...") {
			return;
		}
		onPageChange(page);
	};

	const pages = generateDisplayedPages();

	return (
		<div className="flex items-center flex-wrap my-12">
			<p className="">
				Displaying {(activePage - 1) * rowsPerPage + (length === 0 ? 0 : 1)} to{" "}
				{Math.min(activePage * rowsPerPage, length)} of {length} {dataName}
			</p>
			<div className="flex items-center ml-auto flex-wrap">
				<DropdownMenu>
					<DropdownMenuTrigger asChild>
						<button className="btn btn-white btn-sm text-blue-600 fw-bold border-white rounded pl-0 mr-4">
							{dataName} Per Page: <span className="ml-4">{rowsPerPage}</span>
						</button>
					</DropdownMenuTrigger>
					<DropdownMenuContent>
						{[10, 25, 50].map((item, index) => (
							<DropdownMenuItem
								key={index}
								onClick={() => {
									setRowsPerPage(item);
								}}
							>
								{item}
							</DropdownMenuItem>
						))}
					</DropdownMenuContent>
				</DropdownMenu>
				<nav className="flex items-center gap-1">
					<button
						onClick={() => handlePageChange(currentPage - 1)}
						disabled={currentPage === 1}
						className="px-3 py-1 rounded border disabled:opacity-50"
					>
						&laquo;
					</button>
					{pages.map((page, index) => (
						<button
							key={index}
							onClick={() => handlePageChange(page)}
							className={`px-3 py-1 rounded border ${page === currentPage ? "bg-blue-500 text-white" : "hover:bg-gray-100"} ${page === "..." ? "cursor-default" : ""}`}
						>
							{page}
						</button>
					))}
					<button
						onClick={() => handlePageChange(currentPage + 1)}
						disabled={currentPage === totalPages}
						className="px-3 py-1 rounded border disabled:opacity-50"
					>
						&raquo;
					</button>
				</nav>
			</div>
		</div>
	);
}

export default EllipsisPagination;
